import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const cmpDefaultApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDefaultCmpConfig: builder.query({
      query: () => {
        return {
          url: `/cmp/default/configuration`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: 'default' }],
    }),
    getDefaultCmpConfigVendors: builder.query({
      query: ({lang}) => {
        const queryString = lang ? `?lang=${lang}` : ''
        return {
          url: `/cmp/default/vendors${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `vendors:${JSON.stringify(arg)}` }],
    }),
    getDefaultCmpConfigPurposes: builder.query({
      query: ({lang}) => {
        const queryString = lang ? `?lang=${lang}` : ''
        return {
          url: `/cmp/default/purposes${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `purposes:${JSON.stringify(arg)}` }],
    }),
    updateDefaultCmpConfig: builder.mutation({
      query: ({config}) => ({
        url: `/cmp/default/configuration`,
        method: 'PUT',
        body: config,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    getDefaultCmpAvailableVendors: builder.query({
      query: () => {
        return {
          url: `/cmp/default/vendors/available`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `available_vendors:${JSON.stringify(arg)}` }],
    }),
    addDefaultCmpConfigVendor: builder.mutation({
      query: ({vendorId}) => ({
        url: `/cmp/default/vendors/${vendorId}`,
        method: 'PUT',
        body: {active: true}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    createDefaultCmpConfigVendor: builder.mutation({
      query: ({vendor}) => ({
        url: `/cmp/default/vendors`,
        method: 'POST',
        body: vendor,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    updateDefaultCmpConfigVendor: builder.mutation({
      query: ({vendorId, vendor}) => ({
        url: `/cmp/default/vendors/${vendorId}`,
        method: 'PUT',
        body: vendor,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    deleteDefaultCmpConfigVendor: builder.mutation({
      query: ({vendorId}) => ({
        url: `/cmp/default/vendors/${vendorId}`,
        method: 'PUT',
        body: {active: false}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    addDefaultCmpConfigConsentable: builder.mutation({
      query: ({consentableType, consentableId}) => ({
        url: `/cmp/default/${consentableType}s/${consentableId}`,
        method: 'PUT',
        body: {active: true}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    createDefaultCmpConfigPurpose: builder.mutation({
      query: ({purpose}) => ({
        url: `/cmp/default/purposes`,
        method: 'POST',
        body: purpose,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    updateDefaultCmpConfigPurpose: builder.mutation({
      query: ({purposeId, purpose}) => ({
        url: `/cmp/default/purposes/${purposeId}`,
        method: 'PUT',
        body: purpose,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    removeDefaultCmpConfigConsentable: builder.mutation({
      query: ({consentableType, consentableId}) => ({
        url: `/cmp/default/${consentableType}s/${consentableId}`,
        method: 'PUT',
        body: {active: false}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),


  }),
  overrideExisting: false
})

export const {
  useGetDefaultCmpConfigQuery,
  useGetDefaultCmpConfigVendorsQuery,
  useGetDefaultCmpConfigPurposesQuery,
  useUpdateDefaultCmpConfigMutation,
  useLazyGetDefaultCmpAvailableVendorsQuery,
  useUpdateDefaultCmpConfigVendorMutation,
  useCreateDefaultCmpConfigVendorMutation,
  useAddDefaultCmpConfigVendorMutation,
  useDeleteDefaultCmpConfigVendorMutation,
  useAddDefaultCmpConfigConsentableMutation,
  useCreateDefaultCmpConfigPurposeMutation,
  useUpdateDefaultCmpConfigPurposeMutation,
  useRemoveDefaultCmpConfigConsentableMutation,
} = cmpDefaultApiSlice

